<template>
    <report-layout
        :report="report"
        :identity-verified="identity_verified"
        current-step="terms_and_conditions"
    >
        <div class="overflow-hidden shadow-xl rounded-lg p-6 bg-white">
            <div class="">
                <h4 class="text-3xl text-left font-bold leading-7 text-gray-700 sm:text-2xl sm:truncate">
                    Terms and Conditions
                </h4>
                <form @submit.prevent="update" class="space-y-8 bg-gray divide-y divide-gray-200">
                    <div class="space-y-8 divide-y divide-gray-200">
                        <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="sm:col-span-6">
                                <terms-and-conditions-form :terms="terms" @scrolled-to-bottom="hasScrolledToBottom = true" />
                            </div>
                            <p v-text="form.errors.terms_and_conditions" class="text-red-500 text-sm"></p>
                            <input type="hidden" v-if="hasScrolledToBottom" v-model="form.terms_and_conditions" />
                        </div>
                    </div>
                    <div class="py-5">
                        <div class="font-bold mt-2">RentRisk User Acknowledgment Statement</div>
                        <div class="mt-3">As a valued user of RentRisk's tenant screening services, we are committed to providing you with not only accurate tenant screening solutions but also valuable insights and information related to the rental market and industry trends. We believe in keeping you informed and empowered.  By checking the box below, you acknowledge your interest in receiving additional rental market information, industry trends, emails, and our newsletter featuring content and discussions relevant to the real estate and rental industry.</div>
                        <div class="my-4">
                            <input type="checkbox" v-model="form.newsletter" class="focus:ring-rent-risk-blue-400 h-4 w-4 text-rent-risk-blue-400 border-gray-300 rounded" />
                            Yes, I am interested in receiving additional rental market information, industry trends, emails, and the RentRisk newsletter.
                        </div>
                        <div>
                            Your trust is important to us, and we will always respect your preferences and privacy. You can unsubscribe at any time from these communications by following the instructions in the emails we send.  Thank you for choosing RentRisk. We look forward to keeping you informed and engaged with the latest developments in the real estate and rental market.
                        </div>
                    </div>
                    <div class="pt-5 grid grid-cols-6 gap-4">
                        <div class="col-end-7 col-span-2  flex justify-end items-center space-x-2">
                            <!-- 86bc1ymu6: back out to the report list, not the dashboard.
                                 Terms are step 1, so the report is always unpaid here and
                                 reports.dashboard would bounce the user onto the card form. -->
                            <inertia-link :href="route('reports.self-credit-check')" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400">Cancel</inertia-link>
                            <button type="submit" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-rent-risk-blue-400 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400  w-full sm:w-auto">
                                I Agree
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </report-layout>
</template>

<script>
import Icon from '@/Shared/Icon.vue'
import ReportLayout from './ReportLayout.vue'
import FormButton from '@/Shared/FormButton.vue'
import LoadingButton from '@/Shared/LoadingButton.vue'
import SelectInput from "@/Shared/SelectInput.vue"
import TermsAndConditionsForm from '@/Components/TermsAndConditions/TermsAndConditionsForm.vue'

export default {
    components: {
        Icon,
        ReportLayout,
        FormButton,
        LoadingButton,
        SelectInput,
        TermsAndConditionsForm,
    },
    props: {
        report: Object,
        terms: { type: String, default: null },
        version: { type: String, default: null },
        identity_verified: { type: Boolean, default: false },
    },
    remember: 'form',
    data() {
        return {
            hasScrolledToBottom: false,
            form: this.$inertia.form({
                terms_and_conditions: 1,
                newsletter: true,
            }),
            report: this.report,
        }
    },
    methods: {
        update() {
            this.form.post(this.route('reports.update-terms-and-conditions', this.report.id))
        },
        handleScroll: function(el) {
            if((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
                this.hasScrolledToBottom = true;
            }
        }
    },
    computed: {
        isDisabled() {
            return (this.hasScrolledToBottom) ? false : true;
        },
    },
}
</script>
